<template>
  <form @submit.prevent="submit">
    <fields
      :fields="fields.all()"
      :model="model"
      :errors="errors"
      layout="vertical" />
    <div class="form-group">
      <b-button
        type="submit"
        variant="primary">
        Save
      </b-button>
      <b-button
        type="button"
        variant="light"
        @click="cancel">
        Cancel
      </b-button>
    </div>
  </form>
</template>

<script>
import Layout from '../layouts/Default.vue';
import ResourceFormMixin from '../mixins/ResourceFormMixin';
import { Field } from 'stylemix-base'
import Proxy from './Proxy';
import isPlainObject from 'lodash-es/isPlainObject'

export default {
  name: 'MenuForm',

  components: {
    Layout,
  },
  mixins: [ResourceFormMixin],

  data() {
    return {
      model: {}
    }
  },

  watch: {
    'model.item_type': function(type) {
      return this.changeResource(type);
    }
  },
  created() {
    this.loadForm(Proxy);
  },

  methods: {
    loadField(Proxy, type) {
      let promise;

      promise = new Proxy().getField(type);

      promise.then((result) => {
        const field = isPlainObject(result.field) ? result.field : {};
        const currentField = this.fields.get('resource');
        const typeField = currentField.component;

        if (typeField === 'select-field') {
          this.model.resource = '';
        }

        Object.assign(currentField, field);

        if (typeField === 'select-field') {
          this.model.resource = null;
        }

        return result;
      });

      return this.withUiBlocker(promise)
    },

    submit() {
      this.save(Proxy)
        .then(() => {
          this.$toast.success('Menu item was saved successfully');
        });
    },

    changeResource(typeResource) {
      this.loadField(Proxy, typeResource)
    }
  }

};
</script>
